import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useSetName = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (payload: { id: string; name: string }) => {
      dispatch({
        type: 'UPDATE_SPLIT_TEST_NAME',
        payload,
      });
    },
    [dispatch],
  );
};
